import React from "react";
import Switch from "react-switch";

const Switcher = ({
  checked,
  onChange,
  color = "#DE8556",
  disable = false,
  onOfColor = "#b1b1b1",
}) => (
  <Switch
    width={34}
    height={14}
    onColor={onOfColor}
    offColor={onOfColor}
    onHandleColor={color}
    boxShadow={"0 2px 4px silver, 0 -1px 4px silver"}
    checkedIcon={false}
    uncheckedIcon={false}
    disabled={disable}
    checked={checked}
    onChange={onChange}
    handleDiameter={18}
  />
);

export default Switcher;
